import React, { useState } from "react";
import Button from "../../components/Button/Button";
import BackButton from "../../components/BackButton/BackButton";

function BatteryLevel({ onSelect, onBack }) {
  const [selectedCondition, setSelectedCondition] = useState(null);

  const conditions = [
    {
      id: 1,
      name: "100% - 90%",
      value: 100,
    },
    {
      id: 2,
      name: "89% - 85%",
      value: 89, 
    },
    {
        id: 3,
        name: "84% o menos",
        value: 84, 
      },
  ];

  const handleSelect = (value) => {
    setSelectedCondition(value);
    onSelect(value);
  };

  return (
    <div className="goodCondition">
      <h2>¿Cúal es la capacidad de tu bateria?</h2>
      <p className="description">
        <span>Así es cómo identificas la capacidad de la bateria de tu celular</span>
      </p>
      <p className="sub-description">
        En tu teléfono, ve a{" "}
        <span>Configuración &gt; Bateria &gt; Condición y recarga de la batería &gt; Capacidad máxima</span>
      </p>
      <div className="">
        {conditions.map((item) => (
          <Button
            key={item.id}
            type={selectedCondition === item.value ? "fullBlack" : "full"} // Cambia el estilo dinámicamente
            onClick={() => handleSelect(item.value)}
          >
            {item.name}
          </Button>
        ))}
      </div>
      <BackButton onClick={onBack} />
    </div>
  );
}

export default BatteryLevel;
